"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminMetrics = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var components_1 = require("../shared/components");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
var constants_1 = require("./constants");
var MetricsCategoriesPanel_1 = require("./components/MetricsCategoriesPanel");
var MetricsPropertiesPanel_1 = require("./components/MetricsPropertiesPanel");
var MetricsReviewDrawer_1 = require("./components/MetricsReviewDrawer");
var MetricsSuggestGroupsDrawer_1 = require("./components/MetricsSuggestGroupsDrawer");
var use_metrics_rbac_1 = require("./hooks/use-metrics-rbac");
var use_fetch_metrics_schema_1 = require("./hooks/use-fetch-metrics-schema");
var use_metrics_search_1 = require("./hooks/use-metrics-search");
var use_review_queue_1 = require("./hooks/use-review-queue");
var metrics_utils_1 = require("./utils/metrics-utils");
var ai_hub_elements_api_service_1 = require("../shared/services/ai-hub-elements-api.service");
var ai_hub_readiness_api_service_1 = __importDefault(require("../shared/services/ai-hub-readiness-api.service"));
require("./styles/metrics.scss");
/** Element types exposed in the admin type selector. */
var ELEMENT_TYPE_OPTIONS = [
    { key: 'benefit', text: 'Benefits', icon: 'Trophy' },
    { key: 'budget', text: 'Budget', icon: 'Money' },
    { key: 'data', text: 'Data sources', icon: 'Database' },
    { key: 'integration', text: 'Integrations', icon: 'PlugConnected' },
    { key: 'metric', text: 'Metrics', icon: 'BarChartVertical' },
    { key: 'pain', text: 'Pain points', icon: 'StatusErrorFull' },
    { key: 'persona', text: 'Personas', icon: 'Contact' },
    { key: 'risk', text: 'Risks', icon: 'Warning' },
    { key: 'roadmap', text: 'Roadmap', icon: 'MapDirections' },
    { key: 'tech', text: 'Technologies', icon: 'Devices3' },
];
var DEFAULT_ELEMENT_TYPE = ELEMENT_TYPE_OPTIONS[0].key;
var areStringArraysEqual = function (left, right) {
    if (left.length !== right.length) {
        return false;
    }
    var leftSorted = left.slice().sort();
    var rightSorted = right.slice().sort();
    return leftSorted.every(function (value, index) { return value === rightSorted[index]; });
};
var canAccessProperty = function (permissions, propertyId, elementType) {
    var stripElementPrefix = function (scope) {
        return scope.startsWith('elements.') ? scope.slice('elements.'.length) : scope;
    };
    var includesScope = function (scope) {
        var normalizedScope = stripElementPrefix(scope);
        return permissions.some(function (permission) { return stripElementPrefix(permission) === normalizedScope; });
    };
    var wildcardPermission = elementType + ".*";
    if (includesScope(wildcardPermission)) {
        return true;
    }
    var candidates = new Set([propertyId]);
    var firstDot = propertyId.indexOf('.');
    if (firstDot > -1) {
        var rightPart = propertyId.slice(firstDot + 1);
        candidates.add(rightPart);
        candidates.add(elementType + "." + rightPart);
    }
    return Array.from(candidates).some(function (candidate) { return includesScope(candidate); });
};
/**
 * WsAiHubAdminMetrics - Business metrics configuration for AI Hub admin.
 *
 * Thin orchestrator that wires together:
 *  - {@link useMetricsDraftSchema}: saved/draft state + change tracking
 *  - {@link useMetricsSearch}: derived search analysis
 *  - Local UI state: selected category, selected properties, inline
 *    category edit, success message, delete confirmation, callout.
 *
 * @returns {JSX.Element} Rendered Metrics admin view.
 */
var WsAiHubAdminMetrics = function () {
    var _a;
    var history = react_router_dom_1.useHistory();
    var _b = react_1.useState(DEFAULT_ELEMENT_TYPE), elementType = _b[0], setElementType = _b[1];
    var _c = react_1.useState(false), showInactive = _c[0], setShowInactive = _c[1];
    var draft = use_fetch_metrics_schema_1.useFetchMetricsSchema(elementType, {
        includeDisabled: showInactive,
    });
    var draftSchema = draft.draftSchema, savedSchema = draft.savedSchema, hasChanges = draft.hasChanges, updateDraft = draft.updateDraft, discardChanges = draft.discardChanges, isCategoryChanged = draft.isCategoryChanged, isPropertyChanged = draft.isPropertyChanged, findCategory = draft.findCategory, isLoading = draft.isLoading, isSaving = draft.isSaving, apiError = draft.apiError, saveChangesAsync = draft.saveChangesAsync;
    var _d = react_1.useState(null), selectedCategoryId = _d[0], setSelectedCategoryId = _d[1];
    var _e = react_1.useState([]), selectedPropertyIds = _e[0], setSelectedPropertyIds = _e[1];
    var _f = react_1.useState(null), categoryEdit = _f[0], setCategoryEdit = _f[1];
    var _g = react_1.useState(''), successMessage = _g[0], setSuccessMessage = _g[1];
    var _h = react_1.useState(null), openUseCasesPropertyId = _h[0], setOpenUseCasesPropertyId = _h[1];
    var _j = react_1.useState(false), isDeleteDialogOpen = _j[0], setIsDeleteDialogOpen = _j[1];
    var _k = react_1.useState(false), isTypeSwitchDialogOpen = _k[0], setIsTypeSwitchDialogOpen = _k[1];
    var _l = react_1.useState(null), pendingElementType = _l[0], setPendingElementType = _l[1];
    var _m = react_1.useState(''), searchText = _m[0], setSearchText = _m[1];
    var _o = react_1.useState(false), isReviewDrawerOpen = _o[0], setIsReviewDrawerOpen = _o[1];
    var _p = react_1.useState(false), isSuggestDrawerOpen = _p[0], setIsSuggestDrawerOpen = _p[1];
    var _q = react_1.useState([]), suggestions = _q[0], setSuggestions = _q[1];
    var _r = react_1.useState(false), isSuggesting = _r[0], setIsSuggesting = _r[1];
    var _s = react_1.useState(null), suggestError = _s[0], setSuggestError = _s[1];
    var _t = react_1.useState(false), isOwnerEditorOpen = _t[0], setIsOwnerEditorOpen = _t[1];
    var _u = react_1.useState([]), groupOwnerEditDraftIds = _u[0], setGroupOwnerEditDraftIds = _u[1];
    var _v = react_1.useState({}), groupOwnerDraftByType = _v[0], setGroupOwnerDraftByType = _v[1];
    var _w = react_1.useState({}), propertyManagementDraftByType = _w[0], setPropertyManagementDraftByType = _w[1];
    var reviewQueue = use_review_queue_1.useReviewQueue(elementType);
    // Realign the selected category whenever the schema reloads (initial
    // fetch, type change, or post-save refresh) so the right-hand panel
    // is never blank.
    react_1.useEffect(function () {
        if (selectedCategoryId && draftSchema.some(function (category) { return category.id === selectedCategoryId; })) {
            return;
        }
        setSelectedCategoryId(draftSchema[0] ? draftSchema[0].id : null);
        setSelectedPropertyIds([]);
    }, [draftSchema, selectedCategoryId]);
    var selectedCategory = react_1.useMemo(function () { return findCategory(selectedCategoryId); }, [findCategory, selectedCategoryId]);
    var _x = use_metrics_rbac_1.useMetricsRbac(elementType, (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) || null, ELEMENT_TYPE_OPTIONS), activeRole = _x.activeRole, activePermissions = _x.activePermissions, allowedElementTypeKeys = _x.allowedElementTypeKeys, groupOwnerOptions = _x.groupOwnerOptions, selectedGroupOwnerIds = _x.selectedGroupOwnerIds, ownerOptions = _x.ownerOptions, canEditGroupOwners = _x.canEditGroupOwners, canEditPropertyOwners = _x.canEditPropertyOwners, getSelectedOwnerIdsForProperty = _x.getSelectedOwnerIdsForProperty, syncPropertyOwnerSelection = _x.syncPropertyOwnerSelection, syncGroupOwnerSelection = _x.syncGroupOwnerSelection;
    var effectiveSelectedGroupOwnerIds = react_1.useMemo(function () { return groupOwnerDraftByType[elementType] || selectedGroupOwnerIds; }, [elementType, groupOwnerDraftByType, selectedGroupOwnerIds]);
    var hasPendingGroupOwnerChanges = react_1.useMemo(function () { return Object.prototype.hasOwnProperty.call(groupOwnerDraftByType, elementType); }, [elementType, groupOwnerDraftByType]);
    var stagedPropertyManagementForType = react_1.useMemo(function () { return propertyManagementDraftByType[elementType] || {}; }, [elementType, propertyManagementDraftByType]);
    var hasPendingPropertyManagementChanges = Object.keys(stagedPropertyManagementForType).length > 0;
    var hasAnyPendingChanges = hasChanges || hasPendingGroupOwnerChanges || hasPendingPropertyManagementChanges;
    var ownerTooltipContent = react_1.useMemo(function () {
        var selectedNames = effectiveSelectedGroupOwnerIds
            .map(function (ownerId) { var _a; return ((_a = groupOwnerOptions.find(function (option) { return String(option.key) === String(ownerId); })) === null || _a === void 0 ? void 0 : _a.text) || ''; })
            .filter(function (name) { return !!name; });
        return (react_1.default.createElement("div", { className: "ws-metrics-owner-tooltip-content" },
            react_1.default.createElement("div", { className: "ws-metrics-owner-tooltip-title" }, "Group owners"),
            selectedNames.length > 0 ? (react_1.default.createElement("div", null, selectedNames.join(', '))) : (react_1.default.createElement("div", null, "No owners assigned."))));
    }, [effectiveSelectedGroupOwnerIds, groupOwnerOptions]);
    var visibleElementTypeOptions = react_1.useMemo(function () { return ELEMENT_TYPE_OPTIONS.filter(function (option) { return allowedElementTypeKeys.has(option.key); }); }, [allowedElementTypeKeys]);
    react_1.useEffect(function () {
        var _a;
        if (visibleElementTypeOptions.some(function (option) { return option.key === elementType; })) {
            return;
        }
        var nextElementType = (_a = visibleElementTypeOptions[0]) === null || _a === void 0 ? void 0 : _a.key;
        if (!nextElementType) {
            return;
        }
        setElementType(nextElementType);
        setSelectedCategoryId(null);
        setSelectedPropertyIds([]);
        setSuccessMessage('');
    }, [elementType, visibleElementTypeOptions]);
    var search = use_metrics_search_1.useMetricsSearch(draftSchema, searchText);
    var visibleSelectedProperties = react_1.useMemo(function () {
        var searchedProperties = search.visiblePropertiesFor(selectedCategory);
        if (activeRole !== 'owner') {
            return searchedProperties;
        }
        return searchedProperties.filter(function (property) {
            return canAccessProperty(activePermissions, property.id, elementType);
        });
    }, [activePermissions, activeRole, elementType, search, selectedCategory]);
    var allVisiblePropertyIds = react_1.useMemo(function () { return visibleSelectedProperties.map(function (property) { return property.id; }); }, [visibleSelectedProperties]);
    var visibleSelectedCount = react_1.useMemo(function () {
        return selectedPropertyIds.filter(function (propertyId) { return allVisiblePropertyIds.indexOf(propertyId) >= 0; })
            .length;
    }, [selectedPropertyIds, allVisiblePropertyIds]);
    var moveToOptions = react_1.useMemo(function () {
        return draftSchema.map(function (category) { return ({
            key: category.id,
            text: category.name + " (" + category.properties.length + ")",
            disabled: category.id === selectedCategoryId,
        }); });
    }, [draftSchema, selectedCategoryId]);
    // --- Handlers --------------------------------------------------------
    var dismissSuccessOnEdit = function () {
        if (successMessage) {
            setSuccessMessage('');
        }
    };
    var handleSelectCategory = function (category) {
        setSelectedCategoryId(category.id);
        setSelectedPropertyIds([]);
        if (categoryEdit && categoryEdit.mode === 'edit' && categoryEdit.categoryId !== category.id) {
            setCategoryEdit(null);
        }
    };
    var handleStartAddCategory = function () {
        setCategoryEdit({ mode: 'add', categoryId: null, draftName: '' });
    };
    var handleChangeAddCategoryDraftName = function (nextValue) {
        setCategoryEdit(function (current) {
            return current && current.mode === 'add' ? __assign(__assign({}, current), { draftName: nextValue }) : current;
        });
    };
    var handleStartEditCategory = function (category) {
        var targetCategory = category || selectedCategory;
        if (!targetCategory) {
            return;
        }
        setSelectedCategoryId(targetCategory.id);
        setSelectedPropertyIds([]);
        setCategoryEdit({
            mode: 'edit',
            categoryId: targetCategory.id,
            draftName: targetCategory.name,
        });
    };
    var handleRequestDeleteCategory = function (category) {
        if (categoryEdit || category.properties.length > 0) {
            return;
        }
        setSelectedCategoryId(category.id);
        setSelectedPropertyIds([]);
        setIsDeleteDialogOpen(true);
    };
    var handleConfirmCategoryEdit = function () {
        if (!categoryEdit) {
            return;
        }
        var nextName = categoryEdit.draftName.trim();
        if (!nextName) {
            return;
        }
        if (categoryEdit.mode === 'add') {
            var newId = metrics_utils_1.generateMetricsCategoryId(draftSchema);
            var newCategory_1 = {
                id: newId,
                name: nextName,
                kind: 'predefined',
                properties: [],
            };
            updateDraft(function (next) { return __spreadArrays([newCategory_1], next); });
            setSelectedCategoryId(newId);
            setSelectedPropertyIds([]);
        }
        else if (categoryEdit.categoryId) {
            var categoryId_1 = categoryEdit.categoryId;
            // Once an AI-generated group has been edited by an admin, treat it
            // as a curated/predefined group so the badge no longer claims the
            // name was machine-generated.
            updateDraft(function (next) {
                return next.map(function (category) {
                    return category.id === categoryId_1
                        ? __assign(__assign({}, category), { name: nextName, kind: 'predefined' }) : category;
                });
            });
        }
        setCategoryEdit(null);
        dismissSuccessOnEdit();
    };
    var handleDiscardCategoryEdit = function () {
        setCategoryEdit(null);
    };
    var handleConfirmDeleteCategory = function () {
        if (!selectedCategoryId) {
            setIsDeleteDialogOpen(false);
            return;
        }
        var deletedId = selectedCategoryId;
        updateDraft(function (next) { return next.filter(function (category) { return category.id !== deletedId; }); });
        setSelectedPropertyIds([]);
        setCategoryEdit(null);
        var remaining = draftSchema.filter(function (category) { return category.id !== deletedId; });
        setSelectedCategoryId(remaining[0] ? remaining[0].id : null);
        setIsDeleteDialogOpen(false);
        dismissSuccessOnEdit();
    };
    var handleTogglePropertySelection = function (propertyId) {
        setSelectedPropertyIds(function (current) {
            return current.indexOf(propertyId) >= 0
                ? current.filter(function (id) { return id !== propertyId; })
                : current.concat(propertyId);
        });
    };
    var handleToggleSelectAll = function (nextChecked) {
        if (nextChecked) {
            setSelectedPropertyIds(allVisiblePropertyIds.slice());
        }
        else {
            setSelectedPropertyIds(function (current) {
                return current.filter(function (propertyId) { return allVisiblePropertyIds.indexOf(propertyId) < 0; });
            });
        }
    };
    var handleMoveSelected = function (targetCategoryId) {
        if (!selectedCategoryId || selectedPropertyIds.length === 0) {
            return;
        }
        var sourceCategoryId = selectedCategoryId;
        updateDraft(function (next) {
            var source = next.find(function (c) { return c.id === sourceCategoryId; });
            var target = next.find(function (c) { return c.id === targetCategoryId; });
            if (!source || !target) {
                return next;
            }
            var moved = source.properties.filter(function (property) { return selectedPropertyIds.indexOf(property.id) >= 0; });
            source.properties = source.properties.filter(function (property) { return selectedPropertyIds.indexOf(property.id) < 0; });
            target.properties = target.properties.concat(moved);
            return next;
        });
        setSelectedPropertyIds([]);
        dismissSuccessOnEdit();
    };
    var handleSaveChanges = function () {
        var saveDraftAndOwners = function () { return __awaiter(void 0, void 0, void 0, function () {
            var nextOwnerIds, stagedByPropertyId, _i, _a, propertyId, staged;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!hasChanges) return [3 /*break*/, 2];
                        return [4 /*yield*/, saveChangesAsync()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(hasPendingGroupOwnerChanges && selectedCategory)) return [3 /*break*/, 4];
                        nextOwnerIds = groupOwnerDraftByType[elementType] || [];
                        return [4 /*yield*/, syncGroupOwnerSelection(nextOwnerIds)];
                    case 3:
                        _b.sent();
                        setGroupOwnerDraftByType(function (current) {
                            var next = __assign({}, current);
                            delete next[elementType];
                            return next;
                        });
                        _b.label = 4;
                    case 4:
                        if (!hasPendingPropertyManagementChanges) return [3 /*break*/, 12];
                        stagedByPropertyId = propertyManagementDraftByType[elementType] || {};
                        _i = 0, _a = Object.keys(stagedByPropertyId);
                        _b.label = 5;
                    case 5:
                        if (!(_i < _a.length)) return [3 /*break*/, 11];
                        propertyId = _a[_i];
                        staged = stagedByPropertyId[propertyId];
                        return [4 /*yield*/, syncPropertyOwnerSelection(propertyId, staged.ownerIds)];
                    case 6:
                        _b.sent();
                        if (!(staged.status === 'Ready')) return [3 /*break*/, 8];
                        return [4 /*yield*/, ai_hub_readiness_api_service_1.default.markElementReady(propertyId)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, ai_hub_readiness_api_service_1.default.markElementUnready(propertyId)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10:
                        _i++;
                        return [3 /*break*/, 5];
                    case 11:
                        setPropertyManagementDraftByType(function (current) {
                            var next = __assign({}, current);
                            delete next[elementType];
                            return next;
                        });
                        _b.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        }); };
        void saveDraftAndOwners()
            .then(function () {
            setCategoryEdit(null);
            setIsOwnerEditorOpen(false);
            setSuccessMessage('Metric groups saved successfully.');
        })
            .catch(function () {
            // Error already surfaced via the apiError MessageBar.
        });
    };
    var handleDiscardChanges = function () {
        discardChanges();
        setCategoryEdit(null);
        setIsOwnerEditorOpen(false);
        setGroupOwnerEditDraftIds([]);
        setGroupOwnerDraftByType(function (current) {
            if (!Object.prototype.hasOwnProperty.call(current, elementType)) {
                return current;
            }
            var next = __assign({}, current);
            delete next[elementType];
            return next;
        });
        setPropertyManagementDraftByType(function (current) {
            if (!Object.prototype.hasOwnProperty.call(current, elementType)) {
                return current;
            }
            var next = __assign({}, current);
            delete next[elementType];
            return next;
        });
        setSelectedPropertyIds([]);
        setSuccessMessage('');
        if (!savedSchema.some(function (category) { return category.id === selectedCategoryId; })) {
            setSelectedCategoryId(savedSchema[0] ? savedSchema[0].id : null);
        }
    };
    var handleSwitchElementType = function (nextElementType) {
        setElementType(nextElementType);
        setSelectedCategoryId(null);
        setSelectedPropertyIds([]);
        setSuccessMessage('');
    };
    var closeTypeSwitchDialog = function () {
        setIsTypeSwitchDialogOpen(false);
        setPendingElementType(null);
    };
    var handleConfirmTypeSwitchWithSave = function () {
        if (!pendingElementType) {
            closeTypeSwitchDialog();
            return;
        }
        handleConfirmCategoryEdit();
        handleSwitchElementType(pendingElementType);
        closeTypeSwitchDialog();
    };
    var handleConfirmTypeSwitchWithDiscard = function () {
        if (!pendingElementType) {
            closeTypeSwitchDialog();
            return;
        }
        setCategoryEdit(null);
        handleSwitchElementType(pendingElementType);
        closeTypeSwitchDialog();
    };
    var handleCancelTypeSwitch = function () {
        closeTypeSwitchDialog();
    };
    var handleToggleOwnerEditor = function () {
        if (!canEditGroupOwners || !selectedCategory) {
            return;
        }
        if (!isOwnerEditorOpen) {
            setGroupOwnerEditDraftIds(effectiveSelectedGroupOwnerIds.slice());
            setIsOwnerEditorOpen(true);
            return;
        }
        setIsOwnerEditorOpen(false);
    };
    var handleToggleOwnerDraftSelection = function (ownerId, selected) {
        setGroupOwnerEditDraftIds(function (current) {
            return selected
                ? current.includes(ownerId)
                    ? current
                    : current.concat(ownerId)
                : current.filter(function (existingId) { return existingId !== ownerId; });
        });
    };
    var handleSaveOwnerDraft = function () {
        if (!selectedCategory) {
            setIsOwnerEditorOpen(false);
            return;
        }
        var nextDraftIds = groupOwnerEditDraftIds.slice();
        setGroupOwnerDraftByType(function (current) {
            var _a;
            if (areStringArraysEqual(nextDraftIds, selectedGroupOwnerIds)) {
                var next = __assign({}, current);
                delete next[elementType];
                return next;
            }
            return __assign(__assign({}, current), (_a = {}, _a[elementType] = nextDraftIds, _a));
        });
        setIsOwnerEditorOpen(false);
    };
    var handleDiscardOwnerDraft = function () {
        setGroupOwnerEditDraftIds(effectiveSelectedGroupOwnerIds.slice());
        setIsOwnerEditorOpen(false);
    };
    var handleStagePropertyManagement = function (propertyId, ownerIds, status) {
        var persistedOwnerIds = getSelectedOwnerIdsForProperty(propertyId);
        var selectedProperty = visibleSelectedProperties.find(function (property) { return property.id === propertyId; });
        var persistedStatus = (selectedProperty === null || selectedProperty === void 0 ? void 0 : selectedProperty.isReady) ? 'Ready' : 'In progress';
        var hasChangesInDraft = !areStringArraysEqual(ownerIds, persistedOwnerIds) || status !== persistedStatus;
        setPropertyManagementDraftByType(function (current) {
            var _a, _b, _c;
            var currentByType = current[elementType] || {};
            if (!hasChangesInDraft) {
                if (!Object.prototype.hasOwnProperty.call(currentByType, propertyId)) {
                    return current;
                }
                var nextByType = __assign({}, currentByType);
                delete nextByType[propertyId];
                if (Object.keys(nextByType).length === 0) {
                    var next = __assign({}, current);
                    delete next[elementType];
                    return next;
                }
                return __assign(__assign({}, current), (_a = {}, _a[elementType] = nextByType, _a));
            }
            return __assign(__assign({}, current), (_b = {}, _b[elementType] = __assign(__assign({}, currentByType), (_c = {}, _c[propertyId] = {
                ownerIds: ownerIds.slice(),
                status: status,
            }, _c)), _b));
        });
    };
    var handleOpenUseCase = function (useCaseId) {
        history.push(ai_hub_route_utils_1.buildAiHubUseCaseDetailsPath(useCaseId));
    };
    var handleToggleUseCases = function (propertyId) {
        setOpenUseCasesPropertyId(function (current) { return (current === propertyId ? null : propertyId); });
    };
    var handleSuggestGroups = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSuggestDrawerOpen(true);
                    setIsSuggesting(true);
                    setSuggestError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ai_hub_elements_api_service_1.suggestElementGroups(elementType)];
                case 2:
                    response = _a.sent();
                    setSuggestions(Array.isArray(response === null || response === void 0 ? void 0 : response.suggestions) ? response.suggestions : []);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setSuggestError(error_1 instanceof Error ? error_1.message : String(error_1));
                    setSuggestions([]);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSuggesting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleApplySuggestion = function (input) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ai_hub_elements_api_service_1.applyElementGroupSuggestion({
                        type: elementType,
                        groupName: input.groupName,
                        description: input.description,
                        memberElementIds: input.memberElementIds,
                    })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, draft.refresh()];
                case 2:
                    _a.sent();
                    setSuccessMessage("Group \u201C" + input.groupName + "\u201D created and " + input.memberElementIds.length + " elements linked.");
                    return [2 /*return*/];
            }
        });
    }); };
    // --- Derived UI state ------------------------------------------------
    var isEditingCategory = categoryEdit !== null;
    var editingCategoryId = categoryEdit && categoryEdit.mode === 'edit' ? categoryEdit.categoryId : null;
    var editingCategoryDraftName = categoryEdit && categoryEdit.mode === 'edit' ? categoryEdit.draftName : '';
    var isAddCategoryDialogOpen = categoryEdit !== null && categoryEdit.mode === 'add';
    var addCategoryDraftName = categoryEdit && categoryEdit.mode === 'add' ? categoryEdit.draftName : '';
    var canConfirmAddCategory = addCategoryDraftName.trim().length > 0;
    var selectAllChecked = allVisiblePropertyIds.length > 0 && visibleSelectedCount === allVisiblePropertyIds.length;
    var selectAllIndeterminate = visibleSelectedCount > 0 && visibleSelectedCount < allVisiblePropertyIds.length;
    var canRenameCategory = function (_category) { return !isEditingCategory; };
    var canDeleteCategory = function (category) {
        return !isEditingCategory && category.properties.length === 0;
    };
    react_1.useEffect(function () {
        setIsOwnerEditorOpen(false);
        setGroupOwnerEditDraftIds([]);
    }, [elementType, selectedCategoryId]);
    react_1.useEffect(function () {
        setPropertyManagementDraftByType(function (current) {
            if (!Object.prototype.hasOwnProperty.call(current, elementType)) {
                return current;
            }
            var next = __assign({}, current);
            delete next[elementType];
            return next;
        });
    }, [showInactive]);
    var getStagedOwnerIdsForProperty = function (propertyId) {
        var staged = stagedPropertyManagementForType[propertyId];
        return staged ? staged.ownerIds : null;
    };
    var getStagedStatusForProperty = function (propertyId) {
        var staged = stagedPropertyManagementForType[propertyId];
        return staged ? staged.status : null;
    };
    var getDeleteCategoryTooltip = function (category) {
        if (isEditingCategory) {
            return 'Finish the current group edit before deleting another group.';
        }
        if (category.properties.length > 0) {
            return 'Only metric groups without any signals can be deleted. Move or remove the signals first.';
        }
        return "Delete \"" + (category.name || constants_1.METRICS_UNTITLED_GROUP) + "\"";
    };
    var matchedSignalCountFor = function (categoryId) {
        if (!search.isSearching) {
            return 0;
        }
        var entry = search.analysisByCategory[categoryId];
        return entry ? entry.matchingProperties.length : 0;
    };
    return (react_1.default.createElement("div", { className: "ws-ai-hub-admin-metrics" },
        react_1.default.createElement("h3", null, "Elements"),
        react_1.default.createElement(office_ui_fabric_react_1.Pivot, { className: "ws-metrics-type-pivot", selectedKey: elementType, onLinkClick: function (item) {
                if (!item || !item.props.itemKey || item.props.itemKey === elementType) {
                    return;
                }
                var nextElementType = item.props.itemKey;
                if (isLoading || isSaving) {
                    return;
                }
                if (categoryEdit) {
                    setPendingElementType(nextElementType);
                    setIsTypeSwitchDialogOpen(true);
                    return;
                }
                if (hasAnyPendingChanges) {
                    handleDiscardChanges();
                }
                handleSwitchElementType(nextElementType);
            }, headersOnly: true }, visibleElementTypeOptions.map(function (option) { return (react_1.default.createElement(office_ui_fabric_react_1.PivotItem, { key: option.key, itemKey: option.key, headerText: option.text, itemIcon: option.icon })); })),
        react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row" },
            react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row-actions" },
                react_1.default.createElement(office_ui_fabric_react_1.SearchBox, { placeholder: "Search groups and elements", value: searchText, disableAnimation: true, onChange: function (_, nextValue) { return setSearchText(nextValue || ''); }, onClear: function () { return setSearchText(''); }, styles: { root: { minWidth: 340, maxWidth: 320 } } }),
                (isLoading || isSaving || reviewQueue.isLoading) && (react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.small, label: isSaving ? 'Saving…' : isLoading ? 'Loading groups…' : 'Checking review queue…', labelPosition: "right", styles: {
                        root: { marginLeft: 12 },
                        label: { fontSize: 12, color: '#605e5c' },
                    } }))),
            react_1.default.createElement("div", { className: "ws-metrics-category-toolbar-row-search" }, !categoryEdit && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Save' }, text: "Save Changes", className: "ws-admin-button-filled-primary", disabled: !hasAnyPendingChanges || isSaving, onClick: handleSaveChanges }),
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Undo' }, text: "Discard Changes", className: "ws-admin-button-neutral", disabled: !hasAnyPendingChanges || isSaving, onClick: handleDiscardChanges }))))),
        apiError && react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.error }, apiError),
        reviewQueue.items.length > 0 && (react_1.default.createElement("div", { className: "ws-metrics-review-banner-slot" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.warning, className: "ws-metrics-review-banner", isMultiline: false, truncated: false, actions: react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Open review queue", iconProps: { iconName: 'OpenPane' }, onClick: function () { return setIsReviewDrawerOpen(true); }, className: "ws-metrics-review-banner-cta" }) },
                react_1.default.createElement("span", { className: "ws-metrics-review-banner-text" },
                    react_1.default.createElement("strong", null, reviewQueue.items.length),
                    "\u00A0extracted",
                    ' ',
                    ((_a = ELEMENT_TYPE_OPTIONS.find(function (o) { return o.key === elementType; })) === null || _a === void 0 ? void 0 : _a.text.toLowerCase()) ||
                        'elements',
                    ' ',
                    "waiting for confirmation.")))),
        successMessage && (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.success, onDismiss: function () { return setSuccessMessage(''); }, dismissButtonAriaLabel: "Close" }, successMessage)),
        react_1.default.createElement("div", { className: "ws-metrics-body" },
            react_1.default.createElement(MetricsCategoriesPanel_1.MetricsCategoriesPanel, { draftSchema: draftSchema, visibleCategories: search.visibleCategories, hasResults: search.hasResults, searchText: searchText, searchMatcher: search.searchMatcher, selectedCategoryId: selectedCategoryId, isCategoryChanged: isCategoryChanged, canRenameCategory: canRenameCategory, canDeleteCategory: canDeleteCategory, getDeleteCategoryTooltip: getDeleteCategoryTooltip, editingCategoryId: editingCategoryId, editDraftName: editingCategoryDraftName, matchedSignalCountFor: matchedSignalCountFor, onSelectCategory: handleSelectCategory, onRenameCategory: handleStartEditCategory, onRequestDeleteCategory: handleRequestDeleteCategory, onChangeRenameDraft: function (category, nextValue) {
                    return setCategoryEdit(function (current) {
                        return current && current.mode === 'edit' && current.categoryId === category.id
                            ? __assign(__assign({}, current), { draftName: nextValue }) : current;
                    });
                }, onConfirmRenameCategory: function () { return handleConfirmCategoryEdit(); }, onDiscardRenameCategory: handleDiscardCategoryEdit, categoryEdit: categoryEdit, onStartAddCategory: handleStartAddCategory, onSuggestGroups: function () {
                    void handleSuggestGroups();
                }, suggestGroupsTitle: "Cluster ungrouped " + elementType + " elements and propose AI-named groups", disableSuggestGroups: isLoading || isSaving, showOwnerAction: canEditGroupOwners, ownerTooltipContent: ownerTooltipContent, ownerOptions: groupOwnerOptions, ownerDraftIds: groupOwnerEditDraftIds, isOwnerEditorOpen: isOwnerEditorOpen, disableOwnerEditor: !selectedCategory || isLoading || isSaving, onToggleOwnerEditor: handleToggleOwnerEditor, onToggleOwnerDraftSelection: handleToggleOwnerDraftSelection, onSaveOwnerDraft: handleSaveOwnerDraft, onDiscardOwnerDraft: handleDiscardOwnerDraft }),
            react_1.default.createElement(MetricsPropertiesPanel_1.MetricsPropertiesPanel, { elementType: elementType, selectedCategory: selectedCategory, visibleProperties: visibleSelectedProperties, ownerOptions: ownerOptions, canEditOwners: canEditPropertyOwners, getSelectedOwnerIdsForProperty: getSelectedOwnerIdsForProperty, isSearching: search.isSearching, searchText: searchText, searchMatcher: search.searchMatcher, selectedPropertyIds: selectedPropertyIds, selectAllChecked: selectAllChecked, selectAllIndeterminate: selectAllIndeterminate, showInactive: showInactive, disableShowInactive: isLoading || isSaving, visibleSelectedCount: visibleSelectedCount, moveToOptions: moveToOptions, openUseCasesPropertyId: openUseCasesPropertyId, isPropertyChanged: isPropertyChanged, getStagedOwnerIdsForProperty: getStagedOwnerIdsForProperty, getStagedStatusForProperty: getStagedStatusForProperty, onToggleShowInactive: function (nextChecked) { return setShowInactive(nextChecked); }, onToggleSelectAll: handleToggleSelectAll, onMoveSelected: handleMoveSelected, onTogglePropertySelection: handleTogglePropertySelection, onToggleUseCases: handleToggleUseCases, onDismissUseCases: function () { return setOpenUseCasesPropertyId(null); }, onOpenUseCase: handleOpenUseCase, onStagePropertyManagement: handleStagePropertyManagement })),
        react_1.default.createElement(components_1.ConfirmDialog, { hidden: !isDeleteDialogOpen, variant: "error", title: "Delete metric group", message: selectedCategory
                ? "Are you sure you want to delete \"" + (selectedCategory.name || constants_1.METRICS_UNTITLED_GROUP) + "\"? This change will apply once you click Save Changes."
                : 'Are you sure you want to delete this metric group?', confirmText: "Delete", cancelText: "Cancel", onConfirm: handleConfirmDeleteCategory, onCancel: function () { return setIsDeleteDialogOpen(false); } }),
        react_1.default.createElement(office_ui_fabric_react_1.Dialog, { hidden: !isTypeSwitchDialogOpen, onDismiss: handleCancelTypeSwitch, dialogContentProps: {
                type: office_ui_fabric_react_1.DialogType.normal,
                title: 'Switch element tab?',
                subText: 'You have an in-progress group name edit. Save to keep it, discard to drop it, or cancel to stay on this tab.',
            }, modalProps: { isBlocking: false } },
            react_1.default.createElement(office_ui_fabric_react_1.DialogFooter, null,
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { onClick: handleConfirmTypeSwitchWithSave, text: "Save" }),
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: handleConfirmTypeSwitchWithDiscard, text: "Discard" }),
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: handleCancelTypeSwitch, text: "Cancel" }))),
        react_1.default.createElement(office_ui_fabric_react_1.Dialog, { hidden: !isAddCategoryDialogOpen, onDismiss: handleDiscardCategoryEdit, dialogContentProps: {
                type: office_ui_fabric_react_1.DialogType.normal,
                title: 'Create metric group',
                subText: 'Enter a name for the new metric group.',
            }, modalProps: { isBlocking: false } },
            react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Group name", value: addCategoryDraftName, placeholder: "Enter group name", autoFocus: true, onChange: function (_event, nextValue) { return handleChangeAddCategoryDraftName(nextValue || ''); }, onKeyDown: function (event) {
                    if (event.key === 'Enter' && canConfirmAddCategory) {
                        handleConfirmCategoryEdit();
                    }
                    if (event.key === 'Escape') {
                        handleDiscardCategoryEdit();
                    }
                } }),
            react_1.default.createElement(office_ui_fabric_react_1.DialogFooter, null,
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { onClick: handleConfirmCategoryEdit, text: "Save", disabled: !canConfirmAddCategory }),
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: handleDiscardCategoryEdit, text: "Discard" }))),
        react_1.default.createElement(MetricsReviewDrawer_1.MetricsReviewDrawer, { isOpen: isReviewDrawerOpen, onDismiss: function () { return setIsReviewDrawerOpen(false); }, items: reviewQueue.items, isLoading: reviewQueue.isLoading, error: reviewQueue.error, onApprove: function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.approve(id, notes)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onReject: function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.reject(id, notes)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onEdit: function (id, body) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, reviewQueue.edit(id, body)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, draft.refresh()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); } }),
        react_1.default.createElement(MetricsSuggestGroupsDrawer_1.MetricsSuggestGroupsDrawer, { isOpen: isSuggestDrawerOpen, onDismiss: function () { return setIsSuggestDrawerOpen(false); }, elementType: elementType, suggestions: suggestions, isLoading: isSuggesting, error: suggestError, onApply: handleApplySuggestion })));
};
exports.WsAiHubAdminMetrics = WsAiHubAdminMetrics;
